import React, { useCallback, useEffect, useRef, useState } from "react";
import APIService from "../../Service/APIService";
import "./ActiveBannerAlertBar.css";

const REFRESH_INTERVAL_MS = 60 * 1000;

const ActiveBannerAlertBar = ({ onAlertVisibilityChange }) => {
  const apiServiceRef = useRef(new APIService());
  const bannerRef = useRef(null);
  const [activeAlert, setActiveAlert] = useState(null);

  const fetchActiveAlert = useCallback(async () => {
    try {
      const response = await apiServiceRef.current.getDataFromBackend(
        "getactivebanneralert"
      );
      const nextAlert = response?.data?.data || null;
      setActiveAlert(nextAlert);
    } catch (_error) {
      setActiveAlert(null);
    }
  }, [onAlertVisibilityChange]);

  useEffect(() => {
    fetchActiveAlert();
    const timer = setInterval(fetchActiveAlert, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [fetchActiveAlert]);

  useEffect(() => {
    if (!bannerRef.current || !activeAlert) {
      onAlertVisibilityChange?.({ hasAlert: false, height: 0 });
      return;
    }

    const element = bannerRef.current;
    const reportHeight = () => {
      onAlertVisibilityChange?.({
        hasAlert: true,
        height: element.offsetHeight || 0,
      });
    };

    reportHeight();

    const resizeObserver = new ResizeObserver(() => {
      reportHeight();
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [activeAlert, onAlertVisibilityChange]);

  if (!activeAlert) return null;

  return (
    <div
      ref={bannerRef}
      className="active-banner-alert-bar"
      role="status"
      aria-live="polite"
    >
      <span className="active-banner-alert-description">
        <strong>{activeAlert.AlertName}</strong> {activeAlert.AlertDescription}
      </span>
    </div>
  );
};

export default ActiveBannerAlertBar;
